import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useSelector, useDispatch } from "react-redux";
import DataBase from "../../dataBase/liquidGuides";
import { slice1Actions } from "../../store/reducer";
import "./Modal.css";
import "./UserInfoModal.css";

const icoUser  = solid("user");
const icoXmark = solid("xmark");

const UserInfoModal = (props) => {
  const dispatch = useDispatch();
  let user_info = useSelector((state) => state.user_info);
  const user_info_id = useSelector((state) => state.user_info_id);
  const [editing, setEditing] = useState(!!props.startEditing);
  const [first, setFirst] = useState(user_info.first_name || "");
  const [last, setLast] = useState(user_info.last_name || "");
  const [error, setError] = useState("");
  const isGuest = !user_info.uid || user_info.uid === "guest";
  let uid        = typeof user_info.uid         === "undefined" ? "" : user_info.uid;
  let email      = typeof user_info.email       === "undefined" ? "" : user_info.email;
  let firstName  = typeof user_info.first_name  === "undefined" ? "" : user_info.first_name;
  let lastName   = typeof user_info.last_name   === "undefined" ? "" : user_info.last_name;

  const startEdit = () => {
    setFirst(firstName || "");
    setLast(lastName || "");
    setError("");
    setEditing(true);
  };
  const saveNames = () => {
    const updated = { ...user_info, first_name: first.trim(), last_name: last.trim() };
    DataBase.updateUser(updated, user_info_id, (res) => {
      if (res.pass === true) {
        dispatch(slice1Actions.setUserInfo({ value: updated }));
        setEditing(false);
      } else {
        setError("Couldn't save your name. Please try again.");
      }
    });
  };

  const rows = [
    { label: "User ID",    value: uid,       mono: true },
    { label: "Email",      value: email,     mono: false },
    { label: "First Name", value: firstName, mono: false },
    { label: "Last Name",  value: lastName,  mono: false },
  ];

  return (
    <div className="modal">
      <Modal
        show={props.show}
        animation={false}
        dialogClassName="ui-dialog"
        aria-labelledby="ui-title"
        centered
        onHide={props.onHide}
      >
        <Modal.Body style={{ padding: 0 }}>
          <div className="ui-shell">

            {/* ── Header ── */}
            <div className="ui-header">
              <div className="ui-header-icon">
                <FontAwesomeIcon icon={icoUser} />
              </div>
              <h2 className="ui-title" id="ui-title">User Info</h2>
              <button className="ui-close" onClick={props.onHide}>
                <FontAwesomeIcon icon={icoXmark} />
              </button>
            </div>

            {/* ── Body ── */}
            <div className="ui-body">
              <div className="ui-card">
                {rows.map((row, i) => (
                  <React.Fragment key={row.label}>
                    {i > 0 && <div className="ui-divider" />}
                    <div className="ui-row">
                      <span className="ui-row-label">{row.label}</span>
                      {editing && (row.label === "First Name" || row.label === "Last Name") ? (
                        <input
                          className="form-control form-control-sm"
                          style={{ maxWidth: "60%" }}
                          value={row.label === "First Name" ? first : last}
                          onChange={(e) => (row.label === "First Name" ? setFirst(e.target.value) : setLast(e.target.value))}
                        />
                      ) : (
                        <span className={`ui-row-value${row.mono ? " ui-row-value--mono" : ""}`}>
                          {row.value}
                        </span>
                      )}
                    </div>
                  </React.Fragment>
                ))}
              </div>
              {error && <p style={{ color: "#b00020", marginTop: "0.5rem" }}>{error}</p>}
              {!isGuest && (
                <div style={{ marginTop: "0.75rem", textAlign: "right" }}>
                  {editing ? (
                    <>
                      <button className="btn btn-secondary btn-sm" style={{ marginRight: "0.5rem" }} onClick={() => setEditing(false)}>
                        Cancel
                      </button>
                      <button className="btn btn-primary btn-sm" onClick={saveNames}>
                        Save
                      </button>
                    </>
                  ) : (
                    <button className="btn btn-outline-secondary btn-sm" onClick={startEdit}>
                      Edit Name
                    </button>
                  )}
                </div>
              )}
            </div>

          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UserInfoModal;
